import { createMenuIcon } from 'src/components/icons/designSystemIcons';

export const HelpCenterHelpDeskIcon = createMenuIcon('Helpdesk');
export const HelpCenterCommunityIcon = createMenuIcon('CommentDots');
export const HelpCenterSupportIcon = createMenuIcon('SquareQuestion');
export const HelpCenterUpdatesIcon = createMenuIcon('Newspaper');
export const HelpCenterShortcutsIcon = createMenuIcon('Stopwatch');
export const HelpCenterReferralsIcon = createMenuIcon('Gift');
